import React from 'react';
import logout from '../Components/Image/logout.png'
import Sidebar from '../Components/Sidebar';
import { Table, InputGroup, FormControl } from 'react-bootstrap';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// To make rows collapsible
import "bootstrap/js/src/collapse.js";
import { useHistory, Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


import { connect } from 'react-redux'
import { getQATemplates } from '../store/actions/qaTemplateActions'
import { getPODetails, getPOSearch, postPOLineItem, inspectionDashboard } from '../store/actions/poDetailsActions'
import { getDepartmentSearch } from '../store/actions/departmentActions'
import { getInspectionDetailsByInspectorID, postWaiveOffInspection, patchUpdateInspectionStatus, getInspectionDetailsByCallID, getInspectionDetailsByInspectionId } from '../store/actions/inspectionActions'
import AuthHandlerInstance from '../Classes/AuthHandler'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import Loading from '../Components/Loader';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'



class InspectionDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            poNo: this.props.location.state.poNo,
            callNo: this.props.location.state.callId,
            callId: this.props.location.state.callId,
            InspectionId: this.props.location.state.InspectionId,
            poLineItems: this.props.location.state.poLine,
            Inspectiontabledata: [{ "item": "item1" }, { "item": "item2" }, { "item": "item3" }],
            multiCollapseIndex: '',
            modal: false,
            opacity: "",
            waiveOffModalData: [],
            callItems: [],
            inspectionItems: [],
            loading: false
        }
        console.log('state', this.state)

        this.modal = this.modal.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);


    }

    modal() {
        this.setState({ modal: !this.state.modal, template: "", templatedata: [], customStageDropdown: false });
        if (this.state.modal == true) {
            this.setState({ opacity: "" })

        } else {
            this.setState({ opacity: "0.2" })

        }
    }


    handleRowClick = (index) => {
        var multiCollapseIndex = this.state.multiCollapseIndex
        var waiveOffModalData = []
        if (multiCollapseIndex != index || multiCollapseIndex == '') {

            // console.log(this.state.poLineItems[index],'this.props.inspectionReducer.inspectionDetailsByInspectorId[index].poNo')
            // waiveOffModalData.poNo = this.state.poLineItems[index].poNo
            // waiveOffModalData.poLineItemId = this.state.poLineItems[index].poLineItemId
            // waiveOffModalData.createdOn = this.state.poLineItems[index].createdOn
            // waiveOffModalData.deliveryDate = this.state.poLineItems[index].deliveryDate
            // waiveOffModalData.location = this.state.poLineItems[index].location
            // waiveOffModalData.totalLineItemQuantity = this.state.poLineItems[index].totalLineItemQuantity
            // waiveOffModalData.inspectionQuantity = this.state.poLineItems[index].inspectionQuantity
            // waiveOffModalData.InspectionLocation=this.state.poLineItems[index].InspectionLocation
            // waiveOffModalData.lineItemDescription = this.state.poLineItems[index].lineItemDescription
            // waiveOffModalData.stageNameToInspect = this.state.poLineItems[index].stageNameToInspect
            // waiveOffModalData.location = this.state.poLineItems[index].location
            // waiveOffModalData.proposedDate = this.state.poLineItems[index].proposedDate
            // waiveOffModalData.callNo = this.state.poLineItems[index].callNo
            // waiveOffModalData.callId = this.state.poLineItems[index].callId
            //console.log(waiveOffModalData,'waiveoff')
            //alert(waiveOffModalData)
            this.setState({ multiCollapseIndex: index, waiveOffModalData })
        }
    }

    async waiveOff(callId, data) {
        let status = ""
        let itemQuantity = data.totalLineItemQuantity

        let inspectionQuantity = data.inspectionQuantity
        if (itemQuantity == inspectionQuantity)
            status = "Accepted"
        else
            status = "Part Quantity Accepted, Rework Required for Balance"
        // console.log("@@@@@",status)
        let body = {
            inspectionCallId: callId,
            AcceptedQuantity: inspectionQuantity,

            InspectionQuantity: inspectionQuantity,
            comments: "",
            status: status,
            nextPlannedDate: ""
        }

        await this.props.patchUpdateInspectionStatus(callId, body)
        await this.props.postWaiveOffInspection(callId)
        this.modal()
        window.location.reload()
    }



    componentDidMount = async () => {
        await this.setState({ loading: true })
        const form = {
            //  POId: req.params.id,
            PurchaseOrderLineId: 'req.params.lineid',
            QATemplateName: 'req.body.template',
            TemplateId: 'req.body.TemplateId',
            SeqNo: 'req.body.SeqNo',
            StageId: 'req.body.StageId',
        }

        var roles = AuthHandlerInstance.getRoles()
        var userId = AuthHandlerInstance.getUserID()
        let callItems = []
        if (this.state.callId) {
            await this.props.getInspectionDetailsByCallID(this.state.callId)
            if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByCallID) {
                let callItemsData = await this.props.inspectionReducer.inspectionDetailsByCallID
                for (let i = 0; i < callItemsData.length; i++) {
                    await callItems.push(callItemsData[i])
                }
            }
        }
        if (this.state.InspectionId) {
            await this.props.getInspectionDetailsByInspectionId(this.state.InspectionId)
            if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByCallID) {
                let callItemsData = await this.props.inspectionReducer.inspectionDetailsByCallID
                for (let i = 0; i < callItemsData.length; i++) {
                    await callItems.push(callItemsData[i])
                }
            }
        }
        await this.setState({ callItems, loading: false })
    }

    render() {
        const { qaTemplate } = this.props.qaTemplate
        var permissions = AuthHandlerInstance.getPermissions()
        var roles = AuthHandlerInstance.getRoles()
        console.log(this.props.inspectionReducer, '@@@@@@@@@@@@@s@@@@@@@@@')


        // console.log(this.props.poDetails)
        console.log(this.props.inspectionReducer.inspectionDetailsByInspectorId)
        const inspectionDetailsByInspectorId = []
        const waiveOffinspectionDetailsByInspectorIdData = []
        this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorId && this.props.inspectionReducer.inspectionDetailsByInspectorId.map((value, index) => {
            // if (value.poNo === this.state.poNo) {
            //     value.LineItem.map((element, index) => {

            //         console.log(element)
            //         if (this.props.location.state.InspectionId) {
            //             if (value.HasAccepted == true && value.InspectionId === this.state.InspectionId) {
            //                 inspectionDetailsByInspectorId.push(element)
            //             }

            //         } else {
            //             if (value.callId === this.state.callId) {
            //                 inspectionDetailsByInspectorId.push(element)
            //             }
            //         }
            //     })
            // }
        })

        console.log(inspectionDetailsByInspectorId, '!!!!!!!!!!!')
        return (

            <div className="Container-fluid p-4 " style={{ 'height': '100vh' }}>

                <Modal isOpen={this.state.modal}>
                    <ModalHeader HeaderStyle="modal-header modalheaderWide1">
                        <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Waive Off Inspection</h4>
                        <button type="button" className="close" aria-label="Close" onClick={this.modal} style={{ color: 'black' }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>
                    <ModalBody Style="modal-body modalbodysWide1">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-3 font-weight-bold">
                                    PO Number:
                                </div>
                                <div className="col-md-3">
                                    {this.state.waiveOffModalData.poNo}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    PO Line Item:
                                </div>
                                <div className="col-md-2">
                                    {this.state.waiveOffModalData.poLineItemId}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    PO Date:
                                </div>
                                <div className="col-md-3">
                                    {dateFormater(this.state.waiveOffModalData.createdOn)}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    PO Delivery Date:
                                </div>
                                <div className="col-md-3">
                                    {dateFormater(this.state.waiveOffModalData.deliveryDate)}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    Supplier Name:
                                </div>
                                <div className="col-md-3">
                                    {this.state.waiveOffModalData.vendorName}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    Total PO Quantity:
                                </div>
                                <div className="col-md-3">
                                    {this.state.waiveOffModalData.totalLineItemQuantity}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    Item Description:
                                </div>
                                <div className="col-md-3">
                                    {this.state.waiveOffModalData.lineItemDescription}
                                </div>
                                <div className="col-md-3 font-weight-bold ">

                                    Inspection Quantity:
                                </div>
                                <div className="col-md-3 ">
                                    {this.state.waiveOffModalData.inspectionQuantity}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    Stage to Inspect:
                                </div>
                                <div className="col-md-3">
                                    {this.state.waiveOffModalData.stageNameToInspect}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    Location:
                                </div>
                                <div className="col-md-3">
                                    {this.state.waiveOffModalData.location}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    Prposed Date:
                                </div>
                                <div className="col-md-3">
                                    {dateFormater(this.state.waiveOffModalData.proposedDate)}
                                </div>

                                <div className="col-md-3 font-weight-bold ">
                                    Status:
                                </div>
                                <div className="col-md-3">
                                    {this.state.waiveOffModalData.callNo}
                                </div>
                            </div>
                        </div>

                    </ModalBody>
                    <ModalFooter FooterStyle="modal-footer modalfooterWide1">
                        <div className="container-fluid  ">
                            <div className='row'>
                                <div className='col float-right'>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.modal}> Cancel </button>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2  float-right" onClick={() => this.waiveOff(this.state.waiveOffModalData.callId, this.state.waiveOffModalData)}>Waive Off Inspection </button>
                                </div>
                            </div>
                        </div>
                    </ModalFooter>

                </Modal>
                {this.state.loading ?
                    <Loading />
                    :

                    <div className="Container-fluid " style={{ opacity: this.state.opacity }}>
                        <div className="row">
                            <div className="col-md-6 header">
                                <b>PO Number: </b> {this.state.poNo}
                            </div>
                            {
                                this.props.location.state.InspectionId ?
                                    <div className="col-md-6 header">
                                        <b>Inpection ID: </b> {this.state.InspectionId}
                                    </div>
                                    : this.props.location.state.callId ?
                                        <div className="col-md-6 header">
                                            <b>Call ID: </b> {this.state.callId}
                                        </div>
                                        : null
                            }


                        </div>

                        <div className="row  pl-2 pr-4">
                            <div className="col pr-4">
                                <div className="row headerbar-treasury" >
                                    <div className="col pt-2 pb-2 borderheaderbar">PO LineItem NO</div>
                                    <div className="col pt-2 pb-2 borderheaderbar ">Inspection Quantity</div>
                                    <div className="col pt-2 pb-2 borderheaderbar ">Inspection Location</div>
                                    <div className="col pt-2 pb-2 borderheaderbar">Proposed Date</div>
                                    <div className="col pt-2 pb-2 borderheaderbar">Call Type</div>
                                    <div className="col pt-2 pb-2 borderheaderbar">Status</div>
                                    <div className="col pt-2 pb-2 borderheaderbar  ">Actions</div>
                                </div>
                                {
                                    this.state.callItems.length == 0 ? <div className="row justify-content-center">No inspection calls found</div> : null
                                }
                                {
                                    this.state.callItems.map((value, index) =>
                                        this.props.location.state.callId ?
                                            value.CallItemType !== 'RC' ?
                                                (
                                                    <div>

                                                        <div className={value.HasWaivedOff ? 'row  backgroundwaiveOff' : index % 2 == 0 ? 'row border ' : 'row  background '} onClick={() => this.handleRowClick(index)} data-toggle="collapse" data-target={`.multi-collapse${index}`}>

                                                            <div className="col pt-2 pb-2 borderheaderbar headeralign">{value.poLineItemNo}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar headeralign ">{value.inspectionQuantity} {value.Unit}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionLocation}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar ellipsis">{dateFormater(value.proposedDate)}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.stageIdToInspect == null ? 'Final' : 'Stage'}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar ">{value.HasWaivedOff ? 'Inspection has waived off' : value.LineItemstatus !== '' ? value.LineItemstatus : value.InspectionStatus}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar Headeralign">
                                                                <div className='row justify-content-center'>
                                                                    <div className='col-md-4'>
                                                                        <Link to={{ pathname: '/InspectorDetailsInspector', state: { poItemNo: this.state.poNo, callNo: value.callId, polineitemId: value.poLineItemId, IndexLineId: index, InspectionLineItemID: value.InspectionCallItemID, InspectionId: value.InspectionId } }}>
                                                                            <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg" />
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={index == this.state.multiCollapseIndex ? `container collapse multi-collapse${index}` : `container collapse`}>
                                                            <div className="row">
                                                                <div className="col-md-3 ">
                                                                    <b>Item Description :</b>
                                                                </div>
                                                                <div className="col-md-3 ">
                                                                    {value.lineItemDescription}
                                                                </div>
                                                                <div className="col-md-3 ">
                                                                    <b>Vendor Location :</b>
                                                                </div>

                                                                <div className="col-md-3 ">
                                                                    {value.location}
                                                                </div>

                                                                <div className="col-md-3 ">
                                                                    <b>Inspection Call No :</b>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    {value.callNo}
                                                                </div>

                                                                <div className="col-md-3 ">
                                                                    <b>{value.stageIdToInspect == null ? 'Requested to Inspect :' : 'Requested Stage to Inspect :'}</b>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    {value.CallItemType === 'RW' ? (<b>Rework</b>) : value.CallItemType === 'RV' ? (<b>Revisit</b>) : value.CallItemType === 'RJ' ? (<b>Rejected</b>) : ''} {(value.stageIdToInspect == null ? 'Final' : value.stageNameToInspect) + (value.StageCounter ? " " + value.StageCounter : '')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                ) : ''
                                            : this.props.location.state.InspectionId ? (

                                                <div>

                                                    <div className={value.HasWaivedOff ? 'row  backgroundwaiveOff' : index % 2 == 0 ? 'row border ' : 'row  background '} onClick={() => this.handleRowClick(index)} data-toggle="collapse" data-target={`.multi-collapse${index}`}>

                                                        {/* <div className={index%2==0? 'row border ':'row  background '} onClick={()=>this.handleRowClick(index)} data-toggle="collapse" data-target={`.multi-collapse${index}`}> */}

                                                        <div className="col pt-2 pb-2 borderheaderbar headeralign">{value.poLineItemNo}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar headeralign ">{value.inspectionQuantity} {value.Unit}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionLocation}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{dateFormater(value.proposedDate)}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.stageIdToInspect == null ? 'Final' : 'Stage'}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">{value.HasWaivedOff ? 'Inspection has waived off' : value.LineItemstatus !== '' ? value.LineItemstatus : value.InspectionStatus}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar Headeralign ">
                                                            <div className='row justify-content-center'>

                                                                <div className='col-md-4'>
                                                                    <Link to={{ pathname: '/InspectorDetailsInspector', state: { poItemNo: this.state.poNo, callNo: value.callId, polineitemId: value.poLineItemId, IndexLineId: index, InspectionLineItemID: value.InspectionCallItemID, InspectionId: value.InspectionId } }}>
                                                                        <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={index == this.state.multiCollapseIndex ? `container collapse multi-collapse${index}` : `container collapse`}>
                                                        <div className="row">
                                                            <div className="col-md-3 ">
                                                                <b>Item Description :</b>
                                                            </div>

                                                            <div className="col-md-3 ">
                                                                {value.lineItemDescription}
                                                            </div>
                                                            <div className="col-md-3 ">
                                                                <b>Vendor Location :</b>
                                                            </div>

                                                            <div className="col-md-3 ">
                                                                {value.location}
                                                            </div>

                                                            <div className="col-md-3 ">
                                                                <b>Inspection Call No :</b>
                                                            </div>
                                                            <div className="col-md-3">
                                                                {value.callNo}
                                                            </div>

                                                            <div className="col-md-3 ">
                                                                <b>{value.stageIdToInspect == null ? 'Requested to Inspect :' : 'Requested Stage to Inspect :'}</b>
                                                            </div>
                                                            <div className="col-md-3">
                                                                {value.CallItemType === 'RW' ? (<b>Rework</b>) : value.CallItemType === 'RV' ? (<b>Revisit</b>) : value.CallItemType === 'RJ' ? (<b>Rejected</b>) : ''} {(value.stageIdToInspect == null ? 'Final' : value.stageNameToInspect) + (value.StageCounter ? " " + value.StageCounter : '')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                                : ''
                                    )
                                }

                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ qaTemplate: state.qaTemplate, poDetails: state.poDetails, departmentSearch: state.departmentSearchReducer, inspectionReducer: state.inspectionReducer })
export default connect(mapStateToProps, { getQATemplates, getPODetails, getDepartmentSearch, getPOSearch, inspectionDashboard, getInspectionDetailsByInspectorID, postWaiveOffInspection, patchUpdateInspectionStatus, getInspectionDetailsByCallID, getInspectionDetailsByInspectionId })(InspectionDashboard)
